<template>
	<div class="stop_face_register">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">停止人脸注册</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			人脸注册过程中可以中断人脸注册流程。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+(BOOL)skFaceCancelRegPerson;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">无</p>
        
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	返回true：停止或中断人脸注册成功。返回false：停止或中断人脸注册失败。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">BOOL isStop = [SKFaceManagerInterface skFaceCancelRegPerson];</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-iOS','本地接口','停止人脸注册'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.stop_face_register{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/localface/stopFaceRegister.vue